import { webGateway } from '@/ajax';
import { AuthSDK, deleteOtherUrlParams, isNeedAuth } from '@cfx/icorki-jwx';
import { routerInstance } from '@/router';
import util from '@utils/index';
import fquery from '@/utils/fquery';

/** 是否需要授 */
export const getIsNeedAuth = (globalProperties: any) => {
  const pageNeedAuth = util.storage.getItem('isNeedLogin');

  // url链接上携带了 code 参数，说明是从授权页面跳转过来的 默认为不需要授权了
  if (globalProperties.$urlObj.code) return false;

  // 页面需要登录 且 未登录 需要授权
  return pageNeedAuth && isNeedAuth;
};

/**
 * 授权
 * @param globalProperties 全局数据
 * @param showDialog 是否弹窗
 * @returns
 */
export const handleAuth = async (globalProperties?: any) => {
  const { $urlObj } = globalProperties || {};

  // 是否需要授权
  const pageNeedAuth = util.storage.getItem('isNeedLogin');
  if (!pageNeedAuth) return;

  const account = window.sessionStorage.getItem('reportAccount') || fquery(location.hash)?.account;

  // 初始化授权 SDK
  const auth = await new AuthSDK({
    companyId: $urlObj?.account || account,
    subDomain: 'bizWxOfficial',
    webGateway
  });

  if (!$urlObj?.code) {
    // 授权
    auth.initAuthSDKType();
  } else {
    // 换取用户信息
    await auth.setUserInfoV1Code({ appId: $urlObj?.appId, code: $urlObj?.code });
    const newHref = deleteOtherUrlParams();
    // 更改 url 地址，让这个方法在 router.beforeEach 之后执行
    routerInstance?.afterEach(() => window.history.replaceState({ status: 0 }, '', newHref));
  }
};
